import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/ConfirmationPage.module.css'; // Make sure the path is correct
import videoBackground from '../styles/background.mp4';

const ConfirmationPage = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.confirmationPageContainer}>
       <video className={styles.confirmationPageVideoBackground} autoPlay loop muted>
              <source src={videoBackground} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
      
            <header className={styles.confirmationPageheaderMenu}>
              <div onClick={() => navigate('/')} className={styles.confirmationPagelogo}>
                Full Trucking Service
              </div>
              <nav>
                <ul>
                <li onClick={() => navigate('/about')}>About Us</li>
                  <li onClick={() => navigate('/services')}>Services</li>
                  <li onClick={() => navigate('/contact')}>Contact</li>
                  <li onClick={() => navigate('/pricing')}>Register</li>
                </ul>
              </nav>
            </header>
      <h1>Thank you for registering!</h1>
      <p>We will contact you shortly to activate your account.</p>
      <button className={styles.confirmationPageButton} onClick={() => navigate('/')}>
  Go back to Login
</button>

    </div>
  );
};

export default ConfirmationPage;
